import { useSearchParams } from 'react-router';

const SHARE_SECRET_PARAM_KEY = 'shr';

export const parseShareSecretFromParams = (params: string | undefined) => {
  const paramsObject = new URLSearchParams(params);
  return paramsObject.get(SHARE_SECRET_PARAM_KEY) ?? undefined;
};

const useShareSecret = () => {
  const [searchParams] = useSearchParams();
  return searchParams.get(SHARE_SECRET_PARAM_KEY) ?? undefined;
};

export default useShareSecret;
